import "moment-timezone";
import React, { Component } from "react";
import { Modal } from 'react-bootstrap';
import ReviewSaleForm from './ReviewSaleForm';



class ReviewSaleModal extends Component {
  render() {
    const { deal, showModal, onConfirmModal, onCloseModal } = this.props
    return (
      <Modal show={showModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Finalise this Deal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         <ReviewSaleForm deal={deal} onCancelSubmit={onCloseModal} onSubmit={onConfirmModal} />
        </Modal.Body>
      </Modal>)
  }
}

export default ReviewSaleModal